import KumovegaError from "./KumovegaError";

export default class ObjectUnprocessable extends KumovegaError {}
